import { Injectable } from '@angular/core';
import { v4 as uuidv4 } from 'uuid';

const REGISTER_UUID = 'register_uuid';

@Injectable()
export class UuidService {
  public generateUuid = (): string => uuidv4();

  public getRegisterUuid = (): string => {
    const uuid = localStorage.getItem(REGISTER_UUID);

    if (!uuid) {
      const newUuid = this.generateUuid();
      this.setRegisterUuid(newUuid);
      return newUuid;
    }

    return uuid;
  }

  public removeRegisterUuid = (): void =>
    localStorage.removeItem(REGISTER_UUID)

  public setRegisterUuid = (uuid: string): void =>
    localStorage.setItem(REGISTER_UUID, uuid)
}
